// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__7NIb1","productName":"Table_productName__2khPi"};